import {
  images,
  scrolling,
} from 'assets/utilities';

import {
  mlpUgcImages,
  mlpReview,
  faq,
  mlpNav,
  productInfo,
} from 'assets/components';

import './mlp.scss';


const getOffsetTop = function(el) {
  let offsetTop = 0;
  let element = el;

  while(element) {
    offsetTop += element.offsetTop;
    element = element.offsetParent;
  }

  return offsetTop;
};

const scrollToSection = function(e) {
  const target = e.currentTarget;
  const href = target.getAttribute('href');
  const section = href && href[0] === '#' ? document.querySelector(href) : null;

  // console.log('HREF');
  // console.log(target.getAttribute('href'));

  if (section) {
    e.preventDefault();

    let top = getOffsetTop(section);

    $('html').animate({
      scrollTop: top
    }, 'slow');
  }
};

const destroy = function destroyPage() {
  mlpUgcImages.destroy();
  mlpReview.destroy();
  faq.destroy();
  mlpNav.destroy();
  productInfo.destroy();

  [].forEach.call(
    document.querySelectorAll('.js-mlp-link'),
    (el) => {
      el.removeEventListener('click', scrollToSection);
    },
  );
};

const init = function initPage(props = {}) {
  window.scrollTo(0, 0);
  scrolling.rebuildCache();
  images.init();
  mlpUgcImages.init();
  mlpReview.init();
  faq.init();
  mlpNav.init();
  productInfo.init({ changeState: props.changeState });

  [].forEach.call(
    document.querySelectorAll('.js-mlp-link'),
    (el) => {
      el.addEventListener('click', scrollToSection);
    },
  );
};

export default {
  destroy,
  init,
};
